export default "__VITE_ASSET__Bd5S$wKi__"